import { Volume2, VolumeX } from 'lucide-react';
import { useAudio } from '@/context/AudioContext';

const MusicControl = () => {
  const { isMuted, toggleMute } = useAudio();

  return (
    <button
      data-testid="music-control-btn"
      onClick={toggleMute}
      className="music-control"
      title={isMuted ? "Play music" : "Mute music"}
    >
      {isMuted ? (
        <VolumeX className="w-6 h-6 text-muted-foreground" />
      ) : (
        <Volume2 className="w-6 h-6 text-seagreen" />
      )}
    </button>
  );
};

export default MusicControl;
